module.exports = __webpack_public_path__ + "static/photography-cfe81f4ca575624ffd41f31d897b7dba.png";